import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { FRAUD_ANALYSIS_DEFAULT_CLIENT_TYPE } from 'features/fraudAnalysis'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/'
)({
  beforeLoad: ({ params: { subscriptionId, labelSlug } }) => {
    // Redirect to the default client type if no client type is specified in the URL.
    throw redirect({
      to: AppRoute.FraudAnalysisModelDetailsOverview,
      params: { subscriptionId, labelSlug, clientType: FRAUD_ANALYSIS_DEFAULT_CLIENT_TYPE },
      replace: true,
    })
  },
})
